import { render, staticRenderFns } from "./AreasDialog.vue?vue&type=template&id=5c8915e2&scoped=true&"
import script from "./AreasDialog.vue?vue&type=script&lang=js&"
export * from "./AreasDialog.vue?vue&type=script&lang=js&"
import style0 from "./AreasDialog.vue?vue&type=style&index=0&id=5c8915e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8915e2",
  null
  
)

export default component.exports